<template>
  <p class="sup-description">
    <slot />
  </p>
</template>

<style scoped>
.bold {
  font-weight: var(--font-weight-bold);
}
.sup-description {
  font-size: var(--font-size-14px);
  font-weight: var(--font-weight-regular);
}
.gray-1 {
  color: var(--font-gray-1);
}
.gray-2 {
  color: var(--font-gray-2);
}
.gray-3 {
  color: var(--font-gray-3);
}
</style>
